import React from "react"
import { useSelector } from "react-redux"
import QRCode from 'react-qr-code';

const QRcode = () => {
    const username = useSelector(store => store.user.username)
    const createdAt = useSelector(store => store.reply.createdAt)
    const code = `GlucoNutris app questionnaire voucher for username: ${username}; createdAt: ${createdAt}`

    return (

        <QRCode
            title="GlucoNutris questionnaire voucher"
            value={code}
            bgColor={"#D7DFFB"}
            fgColor={"#46017B"}
            size={300}
            level={"H"}
        />
    )
}
export default QRcode
